// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"5":"home-desktop-taxonomy-css","671":"home-desktop-taxonomy","939":"browse-card-ui"}[chunkId] || chunkId) + "-" + {"5":"13350221ef","289":"9d7b0ef8a7","671":"91941fd09e","939":"fbfad48960"}[chunkId] + ".js";
};